import { type ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import cx from 'clsx';
import { useSegment } from '@repo/poly-hooks/segment';
import { useOnMount } from '@repo/shared-kit/hooks/use-on-mount';
import { BackButton } from '@repo/shared-kit/registration/back-button/back-button';
import illustrationSrc from '@repo/visual-assets/illustrations/ill-es-general-not-eligible.svg';
import { NotSupportedActivitySubtitle } from './not-supported-activity-subtitle';
import styles from './not-supported-activity-route.module.css';

export function NotSupportedActivityContent({
  isPending = false,
  onBack,
}: {
  isPending?: boolean;
  onBack?: () => void;
}): ReactNode {
  const segment = useSegment();

  useOnMount(() => {
    segment.track('onboarding_blacklisted_activity_screen_loaded');
  });

  return (
    <div className={styles.wrapper} data-testid="not-supported-activity">
      <img
        alt=""
        className={cx(styles.illustration, 'mb-32')}
        data-testid="not-supported-activity-illustration"
        role="presentation"
        src={illustrationSrc}
      />
      <h1 className="heading-section mb-16 align-center" data-testid="not-supported-activity-title">
        <FormattedMessage id="customer-registration-kit.register-kyb.unsupported-activity.title" />
      </h1>
      <p className="body-standard align-center" data-testid="not-supported-activity-subtitle">
        <NotSupportedActivitySubtitle />
      </p>
      {onBack ? (
        <div className={styles.controls}>
          <BackButton
            data-testid="not-supported-activity-back"
            isPending={isPending}
            onPress={onBack}
          />
        </div>
      ) : null}
    </div>
  );
}
